<template>
  <a-select
    showSearch
    placeholder="请选择诊断模型"
    optionFilterProp="children"
    style="width: 100%"
    @change="handleChange"
    :filterOption="filterOption"
  >
    <a-select-option v-for="item in values" :key="item.model_id" :disabled="item.disabled || false">{{ item.model_description }}</a-select-option>
  </a-select>
</template>

<script>
import { getItemModelList } from '@/api/model'

export default {
  name: 'SelectModel',
  data () {
    return {
      values: [],
      value: ''
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      var storedModels = this.$store.getters.diagnoseModels
      if (storedModels.length != 0) this.values = storedModels
      else {
        const _this = this
        this.$store.dispatch('FetchDiagnoseModels').then(diagnoseModels => {
          _this.values = diagnoseModels
        }).catch(err => {
          this.likeHospitals.push({ key: '', value: '未添加模型', disabled: true })
        })
      }
    },
    handleChange (value) {
      this.value = value
      this.$emit('modal_changed', value)
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}

</script>
